export default {
      id: "ic_copy_black-usage",
      viewBox: "0 0 10 10",
      url: "/" + "images/icons.3.109.2.svg#ic_copy_black-usage",
      toString: function () {
        return this.url;
      }
    }